import React from 'react'

function RocketLaunchIcon(props: any) {
  return React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24',
        fill: 'currentColor',
        'aria-hidden': 'true'
      },
      props
    ),
    React.createElement('path', {
      fill: props?.color ?? 'currentColor',
      d: 'M11.1596 3.57127C8.13013 2.95077 4.90113 4.27227 2.60813 7.19177C2.45171 7.39077 2.46867 7.67527 2.64763 7.85427L5.02663 10.2338C6.62152 7.63771 8.70422 5.3752 11.1596 3.57127Z'
    }),
    React.createElement('path', {
      fill: props?.color ?? 'currentColor',
      d: 'M13.7556 18.9627L16.1476 21.3542C16.3266 21.5332 16.6111 21.5502 16.8101 21.3937C19.7476 19.0857 21.0701 15.8327 20.4206 12.7872C18.6145 15.2532 16.3519 17.3496 13.7556 18.9627H13.7556Z'
    }),
    React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M22.9751 0.500788C23.1176 0.492674 23.2565 0.547508 23.3551 0.650788C23.4551 0.750657 23.5081 0.888159 23.5011 1.02929C22.7246 14.6878 10.8011 19.4213 10.6801 19.4678C10.623 19.4898 10.5623 19.501 10.5011 19.5008C10.3685 19.5008 10.2413 19.4481 10.1476 19.3543L4.6476 13.8543C4.50864 13.7155 4.46384 13.5081 4.5331 13.3243C4.5791 13.2033 9.2541 1.21729 22.9751 0.500788ZM11.5011 10.5008C11.5011 11.6054 12.3965 12.5008 13.5011 12.5008C14.6057 12.5008 15.5011 11.6054 15.5011 10.5008C15.5011 9.39622 14.6057 8.50079 13.5011 8.50079C12.3965 8.50079 11.5011 9.39622 11.5011 10.5008Z',
      clipRule: 'evenodd',
      fill: props?.color ?? 'currentColor'
    }),
    React.createElement('path', {
      d: 'M6.12262 17.8792C4.95021 16.7094 3.05204 16.7094 1.87962 17.8792C0.801125 18.9572 0.529625 22.5597 0.501125 22.9672C0.491837 23.1056 0.540386 23.2415 0.635179 23.3427C0.729973 23.4438 0.862503 23.5011 1.00112 23.5007H1.03462C1.44212 23.4727 5.04462 23.2007 6.12262 22.1232C7.29317 20.9507 7.29317 19.0518 6.12262 17.8792Z'
    })
  )
}

export default RocketLaunchIcon
